























import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment'
import { convertHtmlToMarkdown } from '@/utils'
@Component
export default class PlanList extends Vue {
  @Prop({ type: Boolean, default: false })
  loading!: boolean
  @Prop({ type: Array, default: () => [] })
  planList!: any[]
  moment = moment
  convertHtmlToMarkdown: any = convertHtmlToMarkdown
  currentState: string = 'all'
  text: string =
    '**【核心完成事项】** 1. 完成了前端登录页面的 UI 开发，还原度达 99%。 2.解决了 API 连接时的 CORS 跨域报错，确保前后端联调顺畅。3.编写了认证服务的单元测试，代码覆盖率提升至 85%。 **【待跟进风险/问题】** 1. Token 刷新机制存在偶发 Bug，需在明日优先排查Redis 缓存配置。 2. CI/CD服务器构建速度较慢，影响测试部署效率，需运维关注。 **【资源需求/协作请求】** 1.需产品经理明日上午确认用户中心最终功能清单。 2.需运维团队协助优化测试环境数据库性能。'
  handlePreview(record: any) {
    this.$emit('preview', record)
  }
}
